/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from 'react'
import { useNavigate } from 'react-router-dom';

interface brandProps{
    listProfile : any
}

const BrandSettings : React.FC <brandProps > = ({listProfile}) => {
    const navigate = useNavigate();
    const editBrand = () => {
        navigate("/settings/brand-update");
      };
  return (
    <div>
           {listProfile?.brandName ? (
                          <div className="your-cuisine mb-3">
                            <div className="head-line">
                              <h6 className="fw-med mb-0">
                                My Brand (Optional)
                              </h6>
                              <a
                                href="#"
                                className="text-link"
                                onClick={editBrand}
                              >
                                Edit
                              </a>
                            </div>
                            <ul className="list-inline mb-0">
                              <li className="list-inline-item">
                                {listProfile?.brandName}
                              </li>
                            </ul>
                          </div>
                        ) : (
                          <div className="your-cuisine mb-3">
                            <a
                              className="empty-wrap"
                              href="#"
                              onClick={editBrand}
                            >
                              Add your brand here...
                              <i
                                className="material-symbols-outlined"
                                onClick={editBrand}
                              >
                                edit
                              </i>
                            </a>
                          </div>
                        )}
    </div>
  )
}

export default BrandSettings
